import { useState } from 'react';
import { usePaypalBillingAgreementEffect } from '../../../../server';

export interface BasketAgreementDataEffectReturn {
  enact: (customerId: number, token: string) => void;
  clear: () => void;
  loading: boolean;
  success: boolean | undefined;
  error?: string;
}

export const useBasketAgreementEffect = (): BasketAgreementDataEffectReturn => {
  const [success, setSuccess] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const paypalBillingAgreement = usePaypalBillingAgreementEffect({
    onComplete: (response: { billingAgreementId: string }) => {
      paypalBillingAgreement.clear();

      if (response.billingAgreementId) {
        setSuccess(true);
        setLoading(false);
      } else {
        setErrorMessage('Basket agreement failed');
        setSuccess(false);
        setLoading(false);
      }
    },
    onError: (error: string) => {
      paypalBillingAgreement.clear();
      setErrorMessage(error);
      setSuccess(false);
      setLoading(false);
    },
  });

  const basketAgreement = (customerId: number, token: string) => {
    setLoading(true);
    paypalBillingAgreement.enact(customerId, token);
  };

  const clear = () => {
    setErrorMessage(undefined);
    setSuccess(undefined);
    setLoading(false);
  };

  return {
    enact: basketAgreement,
    clear,
    loading,
    success,
    error: errorMessage,
  };
};
